import { Fragment, useRef, useState } from "react";
import { Button, OverlayTrigger } from "react-bootstrap";
import { Trash, EyeFill, Link45deg, Paperclip } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { isMobileApp, isWebApp } from "../store/api/CommonFunctions";

const TableRow = (props) => {
    const { row, onclick, cols, indx, buttons, onDoubleClick, forceRowClickInMobile } = props;
    const [dispalyDetail, setDisplay] = useState(false);
    const buttonClicked = useRef(false);
    let mobileCols = cols.filter(c => c.justInMobile && c.colName.toLowerCase() !== "rownumber");
    let webCols = cols.filter(c => !c.justInMobile && c.colName.toLowerCase() !== "rownumber");
    const rowNumber = cols.find(c => c.colName.toLowerCase() === "rownumber");
    const isWeb = isWebApp();
    const isMobile = isMobileApp();
    const rowClick = (item) => {
        if(item.target.tagName.toLowerCase() !=="td")
        {
            return;
        }
        if (buttonClicked.current) {
            buttonClicked.current = false;
            return;
        }
        if (isMobile) {
            setDisplay(!dispalyDetail);
        }
        if (isWeb || forceRowClickInMobile) {
            if (onclick) {
                onclick(item);
            }
        }
    }
    function colValueChanged(e, fn) {
        if (fn) {
            fn({ e, ...row });
        }
    }
    function onRowDoubleClick()
    {
        if(onRowDoubleClick)
        {
            onDoubleClick({ ...row, RowIndex: indx })
        }
    }
    return (
        <Fragment key={indx}>
            <tr className="resultTableRow" onClick={(e) => rowClick({ ...row, RowIndex: indx, ctrlIsDown: e.ctrlKey, target:e.target })} onDoubleClick={onRowDoubleClick} style={{ background: indx % 2 === 0 ? "#e9e9e9" : "#FFF" }}>
                {rowNumber && <td style={{ width: "40px" }}>{indx + 1}</td>}
                {cols.filter(c => c.colName.toLowerCase() !== "rownumber").map((item, i) =>
                    (item.showCondition === undefined || item.showCondition() === true) &&
                    (isWeb || (isMobile && item.justInMobile)) &&
                    <td key={i} style={item.style ? item.style : item.styleCondition ? item.styleCondition(row) : {}} className={item.hasTooltip ? "tooltipCol" : ""}  colname={item.colName}>
                        {item.colType === "currency" &&
                            (!row[item.colName] ? 0 : (item.showNegative ? row[item.colName] : Math.abs(row[item.colName])).toLocaleString(navigator.language, { minimumFractionDigits: 0 }))}
                        {item.colType === "boolean" && <input type="checkbox" className="tableRowColCheck form-check-input" checked={row[item.colName]} disabled={!(item.editable ?? false)} onChange={e => colValueChanged(e, item.onChange)} />}
                        {item.colType === "number" && row[item.colName]}
                        {item.colType === "string" && row[item.colName] && !item.colName.contains("+") &&
                            (row[item.colName]?.substring(0, item.maxTextLength ? item.maxTextLength : row[item.colName].length) + (item.maxTextLength < row[item.colName].length ? "..." : ""))
                        }
                        {item.colType === "string" && item.colName.contains("+") &&
                            (row[item.colName.split("+")[0] ?? ""] + (item.seprator?? " - ") + row[item.colName.split("+")[1] ?? ""])
                        }
                        {item.colType === "color" && row[item.colName] &&
                            <input type="color" readOnly value={row[item.colName]} disabled style={{ padding: 0, border: "none", width: "100%", minWidth: "20px", verticalAlign: "middle" }} />
                        }
                        {item.colType === "calc" && item.valueFunction(row)}
                        {!item.colType && row[item.colName]}
                        {item.hasTooltip && row[item.colName] && item.maxTextLength < row[item.colName].length && <span className="tooltipSpan">{row[item.colName]}</span>}
                    </td>)}
                {
                    isWeb &&
                    <Fragment>
                        {
                            buttons?.length > 0 &&
                            <td style={{ position: "sticky", left: 0, background: "inherit" }}>
                                {buttons.map((b, i) => {
                                    return (
                                        (b.showCondition === undefined || b.showCondition(row) === true) &&
                                        <Fragment key={i}>

                                            {b.type === "delete" &&
                                                <Trash className="rowBtn" color="red" size={18} onClick={() => { buttonClicked.current = true; b.onclick(row) }} style={b.style} />
                                            }
                                            {b.type === "show" &&
                                                <EyeFill className="rowBtn" style={{ marginRight: "3px", ...b.style }} color="#9377d1" size={18} onClick={(e) => { buttonClicked.current = true; b.onclick({ ...row, e }) }} />
                                            }
                                            {b.type === "attach" &&
                                                <Paperclip className="rowBtn" style={{ marginRight: "3px", ...b.style }} color="blue" size={18} onClick={(e) => { buttonClicked.current = true; b.onclick({ ...row, e }) }} />
                                            }
                                            {b.type === "related" &&
                                                <Link45deg className="rowBtn" style={{ marginRight: "3px", ...b.style }} color="blue" size={18} onClick={(e) => { buttonClicked.current = true; b.onclick({ ...row, e }) }} />
                                            }
                                            {b.type === "common" &&
                                                <button className={"rowBtn btn" + (b.tooltip ? " tooltipBtn" : "")} style={{ padding: 0, marginRight: "3px" }} onClick={(e) => { buttonClicked.current = true; b.onclick({ ...row, e }) }}>
                                                    {b.tooltip !== undefined && <span className="btnTooltip">{b.tooltip}</span>}
                                                    {b.icon}
                                                </button>
                                            }
                                            {b.type === "overlay" &&
                                                <OverlayTrigger overlay={b.overlay} placement={b.placement ?? "right"} rootClose={b.rootClose === undefined? true:b.rootClose} trigger="click">
                                                    <button className={"rowBtn btn" + (b.tooltip ? " tooltipBtn" : "")} style={{ padding: 0, marginRight: "3px" }} onClick={(e) => { buttonClicked.current = true; if (b.onclick) { b.onclick({ ...row, e }); } }}>
                                                        {b.tooltip !== undefined && <span className="btnTooltip">{b.tooltip}</span>}
                                                        {b.icon}
                                                    </button>
                                                </OverlayTrigger>
                                            }
                                            {b.type === "link" &&
                                                <Link onClick={(e) => { buttonClicked.current = true; b.onclick({ ...row, e }) }} to={b.to ?? ""}>{b.icon}</Link>
                                            }
                                            {!b.type &&
                                                <Button style={{ marginRight: "3px" }} onClick={(e) => { buttonClicked.current = true; b.onclick({ ...row, e }) }} className={"rowBtn " + (b.className ?? "")}>{b.title}</Button>
                                            }


                                        </ Fragment>)
                                })}
                            </td>
                        }
                    </Fragment>
                }
            </tr>
            {
                isMobile &&
                <tr style={{ display: dispalyDetail ? "table-row" : "none"}}>
                    <td colSpan={mobileCols?.length + (rowNumber ? 1 : 0)} style={{ border: "1px solid #a7aab6", borderRadius: "2px" }}>
                        <div className='row'>
                            {webCols.map((item, i) => {
                                return (
                                    (item.showCondition === undefined || item.showCondition() === true) &&
                                    <Fragment key={i}>
                                        <div className="col-5 mt-2"> {item.colTitle}</div>
                                        <div className="col-7  mt-2" style={{ direction: item.colType === "currency" ? "ltr" : "rtl", overflow:"auto" }}>
                                            {item.colType === "currency" && row[item.colName]?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}
                                            {item.colType === "boolean" && <input type="checkbox" readOnly checked={row[item.colName] ?? false} />}
                                            {item.colType === "number" && row[item.colName]}
                                            {item.colType === "color" && row[item.colName] &&
                                                <input type="color" readOnly value={row[item.colName]} disabled style={{ padding: 0, border: "none", width: "100%", minWidth: "20px", verticalAlign: "middle" }} />
                                            }
                                            {item.colType === "string" && row[item.colName] && !item.colName.contains("+") &&
                                                (row[item.colName]?.substring(0, item.maxTextLength ? item.maxTextLength : row[item.colName].length) + (item.maxTextLength < row[item.colName].length ? "..." : ""))
                                            }
                                            {item.colType === "string" && item.colName.contains("+") &&
                                                (row[item.colName.split("+")[0] ?? ""] + " - " + row[item.colName.split("+")[1] ?? ""])
                                            }
                                            {!item.colType && row[item.colName]}
                                        </div>
                                    </Fragment>
                                )
                            })}
                        </div>
                        <div className="row" style={{ padding: "5px", paddingRight: "10px" }}>
                            <div className="col-md-4" >
                                {buttons?.length > 0 && buttons.map((b, i) => {
                                    return ((b.showCondition === undefined || b.showCondition(row) === true) && <Button key={"btn" + i} variant={b.type === "delete" ? "danger" : "primary"} onClick={() => { b.onclick(row) }} className={b.className} style={b.style}>{b.title}</Button>)
                                }
                                )}
                            </div>
                        </div>
                    </td>
                </tr>

            }
        </Fragment>
    );
}
export default TableRow;